'use client';
import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';

// Timer function
const calculateTimeLeft = () => {
  const targetDate = new Date('2024-12-28T10:00:00'); // Event Date and Time
  const currentDate = new Date();
  const difference = targetDate - currentDate;

  if (difference <= 0) {
    // return { hours: 0, minutes: 0, seconds: 0 };
    return null; // Event has started
  }

  const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((difference / 1000 / 60) % 60);
  const seconds = Math.floor((difference / 1000) % 60);

  return { hours, minutes, seconds };
};

const DamacHeader = () => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  return (
    <>
      {/* Background Section */}
      <div
        className='relative text-white flex flex-col items-center justify-center text-center min-h-screen bg-cover bg-center'
        style={{
          backgroundImage:
            'url(\'https://images.x-space.ae/assets/images/open_house/website/damac_Island.webp\')',
        }}
      >
        {/* Overlay for Contrast */}
        <div className='absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent z-0'></div>

        {/* Content */}
        <div className='z-10 px-6 pt-38 pb-12 sm:pt-15 sm:pb-8'>
          {/* Header */}
          <motion.h1
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
            className='text-[3.5rem] sm:text-[2.5rem] font-bold uppercase text-yellow-400 mb-1'
          >
            Year-End Bonanza
          </motion.h1>

          <motion.h2
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 1.2 }}
            viewport={{ once: true }}
            className='text-[4.8rem] sm:text-[3rem] text-white font-extrabold drop-shadow-md'
          >
            Open House
          </motion.h2>

          <motion.h3
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 1.4 }}
            viewport={{ once: true }}
            className='text-[2rem] sm:text-[1.2rem] mb-6 text-gray-300 italic'
          >
            Discover Luxury Villas & Apartments at Damac Hills
          </motion.h3>

          {/* Highlights Section */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 1.5 }}
            viewport={{ once: true }}
            className='flex flex-wrap justify-center items-center gap-8 mb-6'
          >
            <div className='text-center'>
              <p className='font-bold text-xl text-yellow-400'>50/50</p>
              <p className='text-gray-200'>Payment Plan</p>
            </div>
            <div className='text-center'>
              <p className='font-bold text-xl text-yellow-400'>4%</p>
              <p className='text-gray-200'>DLD Waiver</p>
            </div>
            <div className='text-center'>
              <p className='font-bold text-xl text-yellow-400'>4 Years</p>
              <p className='text-gray-200'>Free Service Charges</p>
            </div>
            <div className='text-center'>
              <p className='font-bold text-xl text-yellow-400'>FREE</p>
              <p className='text-gray-200'>Golden Visa</p>
            </div>
          </motion.div>

          {/* Countdown Timer or Message */}
          {timeLeft ? (
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 1 }}
              viewport={{ once: true }}
              className='text-red-500 font-bold text-[2.5rem] sm:text-[1.5rem] mb-6'
            >
              Time Left: {timeLeft.hours}h : {timeLeft.minutes}m :{' '}
              {timeLeft.seconds}s
            </motion.p>
          ) : (
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{ duration: 1.2, ease: 'easeOut' }}
              viewport={{ once: true }}
              className='mt-8 bg-black/70 p-8 rounded-lg shadow-lg text-center ring-2 ring-yellow-400 animate-pulse'
            >
              <h3 className='text-[2.5rem] sm:text-[2rem] font-bold text-yellow-400'>
                Event is Live!
              </h3>
              <p className='text-gray-200 text-lg sm:text-md mt-4 leading-relaxed'>
                Welcome to the <span className='text-yellow-400'>Year-End Bonanza</span>. 
                Experience the epitome of luxury at Damac Hills. 
                We are thrilled to have you with us!
              </p>
              {/* <div className='mt-6'>
                <a
                  href='#'
                  className='inline-block bg-yellow-400 text-black px-8 py-4 rounded-full font-bold text-lg shadow-md hover:bg-yellow-500 hover:scale-105 transition-transform duration-300'
                >
                  Explore Offers
                </a>
              </div> */}
            </motion.div>
          )}

          {/* Event Details */}
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 1.5 }}
            viewport={{ once: true }}
            className='font-bold text-lg sm:text-lg mb-4 text-yellow-400 mt-5'
          >
            28 December 2024 | Saturday | 10AM - 8PM
          </motion.p>

          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 1.5 }}
            viewport={{ once: true }}
            className='font-bold text-lg sm:text-lg text-gray-200'
          >
            Damac Hills Sales Center, Veneto Show Villa
          </motion.p>

          {/* <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 1.5 }}
            viewport={{ once: true }}
            className='mt-8'
          >
            <a
              href='/damac-openhouse-interest'
              className='relative bg-gold text-black px-8 py-4 rounded-lg font-bold text-xl shadow-lg shimmer-animation hover:bg-yellow-600 hover:animate-none sm:text-lg sm:px-6 sm:py-3'
            >
              Register Now
            </a>
          </motion.div> */}
        </div>
      </div>
    </>
  );
};

export default DamacHeader;
